(($, Drupal) => {
  Drupal.behaviors.videoChatJs = {
    attach(context) {
      const trigger = $('a[href*="#open"]', context);

      if (trigger.length) {
        trigger.click(this.openVideoChatWindow);
      }

    },

    openVideoChatWindow(event) {
      if (event) {
        event.preventDefault();
      }
      window.postMessage({ type: "TRIGGER_DIRECT_VIDEO_CHAT"}, '*');
    },
  };
})
(jQuery, Drupal);
